// eslint-disable-next-line import/prefer-default-export
export const isNewAccount = state => state.getIn(['omniLink', 'newOnlineAccount']);
